export default __webpack_public_path__ + "static/logo-white-6189ec6e281cc198fc7dff2256bb0a4d.png";